// @flow
import { REFRESH_SEARCH, SET_SEARCH_STRING, SET_SUGGEST_STRING } from '../actions/search';

import type { Action } from './types';

const initialState = {
    haveToSearch: false,
    searchString: "",
    suggestString: ""
};

export default function search( state = initialState, action: Action ) {
    switch ( action.type ) {
        case REFRESH_SEARCH:
            return { ...state, haveToSearch: !state.haveToSearch };
        case SET_SEARCH_STRING:
            return { ...state, searchString: action.searchString };
        case SET_SUGGEST_STRING:
            return { ...state, suggestString: action.suggestString };
        default:
            return state;
    }
}
